import axios from "axios";

export const assets = axios.create({
  baseURL: `${process.env.BASE_API_URL || ""}/assets`,
});

export default axios.create({
  baseURL: `${process.env.BASE_API_URL || ""}/api`,
});
